import { debug } from '../../../utils';
import { Observable as O } from 'rxjs/Observable';
import 'rxjs/add/operator/pluck';
import actions from './actions';
import { locate } from './actions';
const log = debug('lego:models/Locate/epics');
import canUseDOM from "can-use-dom";

import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/zip';
import 'rxjs/add/operator/retryWhen';
// TODO once vs ongoing
import createWatchPosition from './locate';

const PERMISSION_DENIED = 1;
const POSITION_UNAVAILABLE = 2;
const TIMEOUT = 3;
const CODE = {
    1: "PERMISSION_DENIED",
    2: "POSITION_UNAVAILABLE",
    3: "TIMEOUT"
};

const watchPosition = createWatchPosition({
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 5000
})

const locateEpic = (action$, store) => action$
  .ofType(actions.locate.START)
  .mergeMap(() => watchPosition
            .flatMap(({message, code, coords}) => {
							if (message) return O.of(locate.reject({ message, code }))
							const { latitude, longitude } = coords
                  const next = [locate.complete({ latitude, longitude })];
							const state = store.getState()
							const Map = state.mapState.mapComponent()
							Map.panTo({lat: latitude, lng: longitude})
                  if (!state.mapState.map_controlled) {
                      next.push(map.setMapLocation({latitude, longitude}))
                  }
                  return next;
              }))
    .catch(err => {
				log(`locate failed: `, err);
        return O.empty();
    });


import { replace } from 'react-router-redux';
import * as map from '../Map/actions';
const setMapLocationEpic = (action$, store) => action$
    .ofType(map.SET_MAP_LOCATION)
    .mergeMap(({payload}) => {
        const state: any = store.getState();
        const { map_location } = payload;
        const { pathname, query } = state.routing.locationBeforeTransitions;
        const { is_controlled } = state.mapState;

        if (!pathname.toLowerCase().startsWith('/search')) return O.empty();

        return O.of(replace({
            pathname,
				    query: {...query, ...map_location}
        }));
    });

export { locateEpic, setMapLocationEpic };



// WEBPACK FOOTER //
// ./src/app/models/Location/epics.ts